<template>
  <div class="project-communication">
    <div class="accordion" role="tablist" v-if="showToGuest('tasks', guestVisibleSections)">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-communication-tasks
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-tasks mr-2"></i>{{ $t('tasks') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-communication-tasks" role="tabpanel" visible>
          <div class="accordion-content px-2 py-2">
            <TaskTable :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>

    <div
      class="accordion"
      role="tablist"
      v-if="showToGuest('employerCommunication', guestVisibleSections)"
    >
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-communication-employer
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-comments mr-2"></i>{{ $t('communication_with_employer') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-communication-employer" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <b-row>
              <b-col lg="6" md="6" sm="12">
                <div class="label">{{ $t('askEmployerCategoryState') }}</div>
                <div>
                  <multiselect
                    :placeholder="$t('askEmployerCategoryState')"
                    v-model="project.askEmployerCategoryState"
                    id="askEmployerCategoryState"
                    :options="getEnumValues('AskEmployerCategoryState')"
                    :allow-empty="true"
                    :show-labels="false"
                    :disabled="!canWriteField('askEmployerCategoryState', guestWritableFields)"
                    deselectLabel
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <b-badge>
                        {{ $t(option) }}
                      </b-badge>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <b-badge>
                        {{ $t(option) }}
                      </b-badge>
                    </template>
                  </multiselect>
                </div>

                <div class="label">{{ $t('askEmployerNote') }}</div>
                <div class="dense-editor">
                  <ckeditor
                    :editor="editor"
                    v-model="project.askEmployerNote"
                    :config="editorConfig"
                    :disabled="!canWriteField('askEmployerNote', guestWritableFields)"
                  ></ckeditor>
                </div>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <div class="label">{{ $t('answerFromEmployerNote') }}</div>
                <div class="dense-editor">
                  <ckeditor
                    :editor="editor"
                    v-model="project.answerFromEmployerNote"
                    :config="editorConfig"
                    :disabled="!canWriteField('answerFromEmployerNote', guestWritableFields)"
                  ></ckeditor>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="accordion" role="tablist" v-if="showToGuest('posts', guestVisibleSections)">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-communication-posts
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-sticky-note mr-2"></i>{{ $t('posts') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-communication-posts" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <ProjectCardPosts :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="accordion" role="tablist" v-if="showToGuest('email', guestVisibleSections)">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-communication-email
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-envelope mr-2"></i>{{ $t('email') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-communication-email" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <ProjectMessages :project="project" :selectedAppointment="selectedAppointment" />
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import { mapGetters } from 'vuex';
import TaskTable from '@/components/TaskTable';
import ProjectMessages from '@/views/Projects/ProjectMessages';
import ProjectCardPosts from '@/views/Projects/ProjectCardPosts';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

export default {
  components: {
    Multiselect,
    ckeditor: CKEditor.component,
    TaskTable,
    ProjectMessages,
    ProjectCardPosts,
  },
  props: {
    project: { type: Object },
    selectedAppointment: { type: Object, default: null },
  },
  data() {
    return {
      editor: InlineEditor,
      editorConfig: {},
      // Guest permissions
      guestWritableFields: {
        askEmployerCategoryState: true,
        askEmployerNote: true,
        answerFromEmployerNote: true,
      },
      guestVisibleSections: {
        employerCommunication: true,
        tasks: true,
        email: false,
        posts: false,
      },
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
  },
  methods: {
    showToGuest,
    canWriteField,
  },
};
</script>

<style scoped lang="scss">
.dense-editor {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}

.ck-editor__editable_inline {
  min-height: 110px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}
</style>
